import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Logo } from "../components/Logo";
import { hwApi } from "./hwApi";
import "../test/testTheme.css";

const AccountCtx = createContext(null);
const GUEST_PATHS = ["/homework/tests", "/homework/test/"];
export const useHwAccount = () => useContext(AccountCtx);

const NAV = [
  ["/homework", "Dashboard", "hw-nav-dashboard"],
  ["/homework/list", "My Homework", "hw-nav-assignments"],
  ["/homework/tests", "Test Series", "hw-nav-tests"],
  ["/homework/planner", "Study Planner", "hw-nav-planner"],
  ["/homework/progress", "My Progress", "hw-nav-progress"],
  ["/homework/payments", "Payments", "hw-nav-payments"],
  ["/homework/profile", "Profile", "hw-nav-profile"],
];

export function HomeworkShell({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [account, setAccount] = useState(location.state?.user || null);
  const [checking, setChecking] = useState(!location.state?.user);

  useEffect(() => {
    if (location.state?.user) return undefined;
    let alive = true;
    hwApi.get("/auth/me")
      .then(({ data }) => { if (alive) { setAccount(data); setChecking(false); } })
      .catch(() => hwApi.post("/auth/refresh")
        .then(() => hwApi.get("/auth/me"))
        .then(({ data }) => { if (alive) { setAccount(data); setChecking(false); } })
        .catch(() => {
          // Guests are welcome on the Test Series pages — one free test, solutions unlock on register.
          if (GUEST_PATHS.some((p) => location.pathname.startsWith(p))) {
            if (alive) { setAccount(null); setChecking(false); }
          } else {
            navigate("/homework/auth", { replace: true });
          }
        }));
    return () => { alive = false; };
  }, [location.state, navigate]);

  const isGuestPath = GUEST_PATHS.some((p) => location.pathname.startsWith(p));
  if (checking || (!account && !isGuestPath)) {
    return <div className="tp-shell"><div className="tp-wrap" style={{ padding: 80, textAlign: "center" }}><p className="tp-muted">Loading…</p></div></div>;
  }

  const logout = async () => {
    await hwApi.post("/auth/logout").catch(() => {});
    navigate("/homework/auth");
  };

  return (
    <AccountCtx.Provider value={account}>
      <div className="tp-shell">
        <div className="tp-topbar"><div className="tp-topbar-inner" style={{ flexWrap: "wrap", gap: 8 }}>
          <a className="tp-brand" href="/homework" data-testid="hw-brand"><Logo size={24} /><span>PRANJAL SIR <b>PHYSICS MENTOR</b></span></a>
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap", alignItems: "center" }}>
            {NAV.filter(([path]) => account || path === "/homework/tests").map(([path, label, tid]) => (
              <a key={path} href={path} data-testid={tid}
                 style={{ fontSize: 13, padding: "6px 10px", borderRadius: 8, textDecoration: "none",
                          color: location.pathname === path ? "#fff" : "#5b6b7c",
                          background: location.pathname === path ? "#1d4ed8" : "transparent" }}>{label}</a>
            ))}
            {account ? (<>
              <span className="tp-note" style={{ marginLeft: 6 }}>{account.name.split(" ")[0]}</span>
              <button className="tp-back" style={{ background: "none", border: "none", cursor: "pointer" }} onClick={logout} data-testid="hw-logout">Logout</button>
            </>) : (
              <a className="tp-btn small" href="/homework/auth" data-testid="hw-guest-login">Login / Register</a>
            )}
          </div>
        </div></div>
        {children}
      </div>
    </AccountCtx.Provider>
  );
}
